<template>
  <div class="backgroud-white cs-appointment-watchApprove">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form label-width="160px">
        <el-form-item label="学生:">
          <span>{{phone}}</span>
        </el-form-item>
        <el-form-item label="当前课程:">
          <span>{{currentCourse + " " + dataIn.courseWeekString}}</span>
        </el-form-item>
        <el-form-item label="免费观看视频共(次):">
          <span>{{totalFreeWatchCount}}</span>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in courseFreeWatchCount"
          :key="index"
          :label="item.courseName + '(次):'"
        >
        <el-tooltip placement="top">
          <div slot="content"> <div v-for="(detail, indexDetail) in item.details" :key="indexDetail">{{detail.WeekText}} &nbsp; {{detail.Count}}<br/></div></div>
          <span>{{item.count}}</span>
        </el-tooltip>
         
        </el-form-item>
        <el-form-item class="su-left-align cs-register-code">
          <el-button
            :disabled="smsBtnDisable"
            v-bind:type="smsBtnClass"
            @click="smsBtnClick"
            class="smsBtn"
          >{{smsBtnText}}</el-button>
          <span>收不到验证码</span>
          <el-tooltip
            class="item"
            effect="dark"
            placement="top"
          >
            <div slot="content">请确认输入的手机号码为10位数<br />北美手机号或11位数中国手机号，<br />若还是无法收到验证码，请联系客服</div>
            <img src="../../assets/question.png">
          </el-tooltip>
        </el-form-item>
        <el-form-item
          prop="code"
          label="验证码"
        >
          <el-input
            placeholder="请输入收到的验证码"
            v-model="form.code"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="reason"
          label="原因"
        >
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.reason"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col class="footer-center">
          <el-button
            type="primary"
            @click="save"
          >确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.el-form-item{
  margin-bottom: 0;
}
</style>


<script>
import { sendSMS } from "../../service/common.service";
import {
  getConfirmWatchData,
  updateWatchApproved
} from "../../service/videoAppointment.service";
export default {
  data() {
    return {
      phone: "",
      currentCourse: "",
      totalFreeWatchCount: "",
      courseFreeWatchCount: [],
      smsBtnDisable: true,
      smsBtnClass: "info",
      smsBtnText: " 发送验证码 ",
      isSendSMS: false,
      timer: null,
      form: {
        code: "",
        reason: ""
      }
    };
  },
  components: {},
  created() {
    this.init();
  },
  props: {
    dataIn: {
      id: Number,
      phone: String,
      courseWeekString: String
    }
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.id) {
        this.setSMSBtnState(false);
        getConfirmWatchData(this.dataIn.id).then(result => {
          if (!!result && result.success) {
            this.phone = result.data.Phone;
            this.currentCourse = result.data.CurrentCourse;
            this.totalFreeWatchCount = result.data.TotalFreeWatchCount;
            let list = [];
            if (!!result.data.CourseFreeWatchCount) {
          
              result.data.CourseFreeWatchCount.forEach(element => {
                let item = list.find(i => i.courseName == element.CourseName);
                if (!!item){
                  item.count += element.Count;
                  item.details.push(element);
                }else{
                  item = {
                    courseName: element.CourseName,
                    count: element.Count,
                    details:[element]
                  };
                  list.push(item);
                }
              });
              
            }
            this.courseFreeWatchCount = list;
          }
        });
      } else {
        this.phone = "";
        (this.currentCourse = ""), (this.totalFreeWatchCount = 0);
        this.courseFreeWatchCount = [];
      }
    },
    save() {
      if (!this.form.code){
        if (!this.form.reason){
          this.$message.warning("请输入原因");
          return;
        }
      }
      updateWatchApproved(
        this.dataIn.id,
        this.form.code,
        this.form.reason
      ).then(result => {
        if (!!result && !!result.success) {
          this.$message.success("确认观看成功");
          this.$emit("close");
        } else {
          this.$message.warning(result.message);
        }
      });
    },
    setSMSBtnState(isDisable) {
      if (isDisable) {
        this.smsBtnDisable = true;
        this.smsBtnClass = "info";
      } else {
        this.smsBtnDisable = false;
        this.smsBtnClass = "primary";
      }
    },
    afterSMSSend() {
      this.isSendSMS = true;
      this.setSMSBtnState(true);
      let count = 60;
      this.smsBtnText = count.toString() + "秒后重新发送";

      let self = this;
      if (self && !self._isDestroyed) {
        self.timer = setInterval(() => {
          if (self && !self._isDestroyed) {
            count--;
            if (count == 0) {
              this.isSendSMS = false;
              this.setSMSBtnState(false);
              this.smsBtnText = " 发送验证码 ";
              clearInterval(self.timer);
            } else {
              this.smsBtnText = count.toString() + "秒后重新发送";
            }
          }
        }, 1000);
      }
    },
    async smsBtnClick() {
      if (this.isSendSMS) return;
      this.smsBtnDisable = true;
      await sendSMS(this.dataIn.phone, 9).then(result => {
        if (!!result) {
          if (result.success) {
            this.$message("验证码发送成功，请注意查收！");
            this.afterSMSSend();
          } else {
            if (result.message) {
              this.$message({
                message: result.message,
                type: "error"
              });
            }
          }
        }
      });
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappWatchApprove.vue